export const ADD_ELEMENT = {
  action: 'ADD_ELEMENT',
  isUndoable: true,
}

export const ADD_MOTION = {
  action: 'ADD_MOTION',
  isUndoable: true,
}

export const ADD_PAGE_AFTER_ID = {
  action: 'ADD_PAGE_AFTER_ID',
  isUndoable: false,
}

// Not undoable, like page CRUD: undo only covers the markup slice, not an artboard's element
// permissions, Slate editors or selection.
export const ADD_ARTBOARD = {
  action: 'ADD_ARTBOARD',
  isUndoable: false,
}

export const ARTBOARD_FRAMED = {
  action: 'ARTBOARD_FRAMED',
  isUndoable: false,
}

export const CLOSE_ARTBOARD_MODAL = {
  action: 'CLOSE_ARTBOARD_MODAL',
  isUndoable: false,
}

export const CLOSE_ASSET_PICKER = {
  action: 'CLOSE_ASSET_PICKER',
  isUndoable: false,
}

export const CROP_IMAGE = {
  action: 'CROP_IMAGE',
  isUndoable: true,
}

export const DELETE_ARTBOARD = {
  action: 'DELETE_ARTBOARD',
  isUndoable: false,
}

export const DELETE_PAGE_BY_ID = {
  action: 'DELETE_PAGE_BY_ID',
  isUndoable: false,
}

export const DESELECT_A_MODE = {
  action: 'DESELECT_A_MODE',
  isUndoable: false,
}

export const DESELECT_ELEMENT = {
  action: 'DESELECT_ELEMENT',
  isUndoable: false,
}

export const DISABLE_DRAGGING_MODE = {
  action: 'DISABLE_DRAGGING_MODE',
  isUndoable: false,
}

export const DISABLE_ELEMENT_PERMISSION = {
  action: 'DISABLE_ELEMENT_PERMISSION',
  isUndoable: false,
}

export const DUPLICATE_ARTBOARD = {
  action: 'DUPLICATE_ARTBOARD',
  isUndoable: false,
}

export const DUPLICATE_PAGE_BY_ID = {
  action: 'DUPLICATE_PAGE_BY_ID',
  isUndoable: false,
}

export const ENABLE_ELEMENT_PERMISSION = {
  action: 'ENABLE_ELEMENT_PERMISSION',
  isUndoable: false,
}

export const FETCH_FILTERS_FAILURE = {
  action: 'FETCH_FILTERS_FAILURE',
  isUndoable: false,
}

export const FETCH_FILTERS_PENDING = {
  action: 'FETCH_FILTERS_PENDING',
  isUndoable: false,
}

export const FETCH_FILTERS_SUCCESS = {
  action: 'FETCH_FILTERS_SUCCESS',
  isUndoable: false,
}

export const FETCH_PREVIEWS_FAILURE = {
  action: 'FETCH_PREVIEWS_FAILURE',
  isUndoable: false,
}

export const FETCH_PREVIEWS_PENDING = {
  action: 'FETCH_PREVIEWS_PENDING',
  isUndoable: false,
}

export const FETCH_PREVIEWS_SUCCESS = {
  action: 'FETCH_PREVIEWS_SUCCESS',
  isUndoable: false,
}

export const FETCH_SPECIMENS_FAILURE = {
  action: 'FETCH_SPECIMENS_FAILURE',
  isUndoable: false,
}

export const FETCH_SPECIMENS_SUCCESS = {
  action: 'FETCH_SPECIMENS_SUCCESS',
  isUndoable: false,
}

export const FLIP_IMAGE = {
  action: 'FLIP_IMAGE',
  isUndoable: true,
}

export const FRAME_ARTBOARD = {
  action: 'FRAME_ARTBOARD',
  isUndoable: false,
}

export const GROUP_ELEMENTS = {
  action: 'GROUP_ELEMENTS',
  isUndoable: true,
}

export const ASSET_FETCH_PENDING = {
  action: 'ASSET_FETCH_PENDING',
  isUndoable: false,
}

export const ASSET_FETCH_DONE = {
  action: 'ASSET_FETCH_DONE',
  isUndoable: false,
}

export const OPEN_ARTBOARD_MODAL = {
  action: 'OPEN_ARTBOARD_MODAL',
  isUndoable: false,
}

export const OPEN_ASSET_PICKER = {
  action: 'OPEN_ASSET_PICKER',
  isUndoable: false,
}

export const OPEN_SPECIMEN_PICKER = {
  action: 'OPEN_SPECIMEN_PICKER',
  isUndoable: false,
}

export const BACK_FROM_SPECIMEN_PICKER = {
  action: 'BACK_FROM_SPECIMEN_PICKER',
  isUndoable: false,
}

export const POPULATE_SPECIMENS_LIST = {
  action: 'POPULATE_SPECIMENS_LIST',
  isUndoable: false,
}

export const RENAME_ARTBOARD = {
  action: 'RENAME_ARTBOARD',
  isUndoable: false,
}

export const REMOVE_ELEMENT = {
  action: 'REMOVE_ELEMENT',
  isUndoable: true,
}

export const REMOVE_MOTION = {
  action: 'REMOVE_MOTION',
  isUndoable: true,
}

export const REORDER_MOTION = {
  action: 'REORDER_MOTION',
  isUndoable: true,
}

export const REPOSITION_ELEMENTS = {
  action: 'REPOSITION_ELEMENTS',
  isUndoable: true,
}

// Undoable unlike the other artboard actions, because it changes the design rather than the set of
// artboards: every element on the board moves and resizes.
export const RESIZE_ARTBOARD = {
  action: 'RESIZE_ARTBOARD',
  isUndoable: true,
}

export const RESIZE_ROTATE_ELEMENTS = {
  action: 'RESIZE_ROTATE_ELEMENTS',
  isUndoable: true,
}

export const RESIZING_STARTED = {
  action: 'RESIZING_STARTED',
  isUndoable: false,
}

export const RESIZING_STOPPED = {
  action: 'RESIZING_STOPPED',
  isUndoable: false,
}

export const SAVE_FAILURE = {
  action: 'SAVE_FAILURE',
  isUndoable: false,
}

export const SAVE_PENDING = {
  action: 'SAVE_PENDING',
  isUndoable: false,
}

export const SAVE_SUCCESS = {
  action: 'SAVE_SUCCESS',
  isUndoable: false,
}

export const START_MOTION_PREVIEW = {
  action: 'START_MOTION_PREVIEW',
  isUndoable: false,
}

export const STOP_MOTION_PREVIEW = {
  action: 'STOP_MOTION_PREVIEW',
  isUndoable: false,
}

export const TOGGLE_MOTION_PREVIEW_LOOP = {
  action: 'TOGGLE_MOTION_PREVIEW_LOOP',
  isUndoable: false,
}

export const SELECT_A_MODE = {
  action: 'SELECT_A_MODE',
  isUndoable: false,
}

export const SELECT_ELEMENT = {
  action: 'SELECT_ELEMENT',
  isUndoable: false,
}

export const SELECT_PAGE = {
  action: 'SELECT_PAGE',
  isUndoable: false,
}

export const SELECT_TEXT_STYLE = {
  action: 'SELECT_TEXT_STYLE',
  isUndoable: false,
}

export const SET_DOCUMENT_PERMISSION = {
  action: 'SET_DOCUMENT_PERMISSION',
  isUndoable: false,
}

export const SET_ARTBOARD_ORDER = {
  action: 'SET_ARTBOARD_ORDER',
  isUndoable: false,
}

export const SET_PAGE_ORDER = {
  action: 'SET_PAGE_ORDER',
  isUndoable: false,
}

export const SET_TEXT_SELECTION = {
  action: 'SET_TEXT_SELECTION',
  isUndoable: false,
}

export const SET_RIGHT_PANEL_TAB = {
  action: 'SET_RIGHT_PANEL_TAB',
  isUndoable: false,
}

export const SET_ZOOM = {
  action: 'SET_ZOOM',
  isUndoable: false,
}

export const SET_AI_LABEL = {
  action: 'SET_AI_LABEL',
  isUndoable: true,
}

export const SWITCH_THEME = {
  action: 'SWITCH_THEME',
  isUndoable: true,
}

export const TERMINATE_UPLOAD_PROGRESS = {
  action: 'TERMINATE_UPLOAD_PROGRESS',
  isUndoable: false,
}

export const TOGGLE_GRID = {
  action: 'TOGGLE_GRID',
  isUndoable: false,
}

export const UNGROUP_ELEMENTS = {
  action: 'UNGROUP_ELEMENTS',
  isUndoable: true,
}

export const TOGGLE_POSITION_UNITS = {
  action: 'TOGGLE_POSITION_UNITS',
  isUndoable: false,
}

export const SHOW_BLEED = {
  action: 'SHOW_BLEED',
  isUndoable: false,
}

export const UPDATE_DOC = {
  action: 'UPDATE_DOC',
  isUndoable: true,
}

export const UPDATE_ELEMENT = {
  action: 'UPDATE_ELEMENT',
  isUndoable: true,
}

export const UPDATE_MOTION = {
  action: 'UPDATE_MOTION',
  isUndoable: true,
}

export const UPDATE_UPLOAD_PROGRESS = {
  action: 'UPDATE_UPLOAD_PROGRESS',
  isUndoable: false,
}

export const SET_NOTIFICATION = {
  action: 'SET_NOTIFICATION',
  isUndoable: false,
}

export const SET_HOVERED_MOTION_ELEMENTS = {
  action: 'SET_HOVERED_MOTION_ELEMENTS',
  isUndoable: false,
}

export const COPY_ELEMENT = {
  action: 'COPY_ELEMENT',
  isUndoable: false,
}

export const PASTE_ELEMENT = {
  action: 'PASTE_ELEMENT',
  isUndoable: true,
}
